import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATElEQVR42n3KywqAIBRFUf///5qFBV2hp5VFNjB3DwIn0YZzRkvxFuPBR0HdP9iFSmeIGHTZXGuZ3ZaA9ztu6hHTPSAvauy4JvBTOAEJdnxRaWkVIAAAAABJRU5ErkJggg=="};
